import { render, staticRenderFns } from "./AddJobSEO.vue?vue&type=template&id=2d33bedd"
import script from "./AddJobSEO.vue?vue&type=script&lang=js"
export * from "./AddJobSEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports